@if (loading()) {
  <section class="text-left animate-in fade-in duration-500">
    <div class="flex items-center justify-between mb-8 pb-4 border-b border-gray-4">
      <div class="flex items-center gap-3">
        <mat-icon class="text-primary scale-110">history_edu</mat-icon>
        <h2 class="text-3xl font-bold text-gray-12">Poursuivre vos créations</h2>
      </div>
      <div class="w-36 h-8 bg-gray-4 rounded-full animate-pulse"></div>
    </div>

    <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
      @for (item of [1, 2, 3]; track item) {
        <etxe-property-draft-card-skeleton />
      }
    </div>
  </section>
} @else if (drafts().length > 0) {
  <section class="text-left animate-in fade-in slide-in-from-bottom-4 duration-700">
    <div class="flex items-center justify-between mb-8 pb-4 border-b border-gray-4">
      <div class="flex items-center gap-3">
        <mat-icon class="text-primary scale-110">history_edu</mat-icon>
        <h2 class="text-3xl font-bold text-gray-12">Poursuivre vos créations</h2>
      </div>
      <span
        class="px-4 py-1.5 bg-indigo-a3 text-indigo-9 text-sm font-bold rounded-full border border-indigo-a4"
      >
        {{ drafts().length }} annonce(s) en attente
      </span>
    </div>

    <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
      @for (draft of drafts(); track draft._id) {
        <etxe-property-draft-card
          [draft]="draft"
          (selected)="draftSelected.emit($event)"
          (deleted)="draftDeleted.emit($event)"
        />
      }
    </div>
  </section>
}
